import { useMediaQuery } from '@material-ui/core';
import { useSelector } from 'react-redux';

export const useResponsive = () => {
  const examinationListDrawer = useSelector((state) => state.gui?.examinationListDrawer);
  const isSmallScreen = useMediaQuery('(max-width: 1400px)');
  const smallScreen = isSmallScreen || examinationListDrawer;

  return { smallScreen };
};
